import { useState } from 'react';
import PaymentReport from './PaymentReport';
import OpenInvoicesReport from './OpenInvoicesReport';
import InvoiceVolumeReport from './InvoiceVolumeReport';

type ReportTab = 'PAYMENTS' | 'OPEN_INVOICES' | 'INVOICE_VOLUME';

const REPORT_TABS: { id: ReportTab; label: string }[] = [
  { id: 'PAYMENTS', label: 'Payments' },
  { id: 'OPEN_INVOICES', label: 'Open Invoices' },
  { id: 'INVOICE_VOLUME', label: 'Invoice Volume' },
];

const BuyerReporting = () => {
  const [activeTab, setActiveTab] = useState<ReportTab>('PAYMENTS');

  return (
    <div className="flex flex-col w-full h-full">
      {/* Tab Navigation */}
      <div className="sticky top-0 bg-white z-30 border-b border-gray-200">
        <div className="px-4">
          {REPORT_TABS.map((tab) => (
            <button
              key={tab.id}
              role="tab"
              aria-selected={activeTab === tab.id}
              onClick={() => setActiveTab(tab.id)}
              className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px transition-colors cursor-pointer bg-transparent ${
                activeTab === tab.id
                  ? 'border-blue-600 text-blue-600 bg-white'
                  : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
              }`}>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex flex-col w-full flex-1 min-h-0 p-4">
        {activeTab === 'PAYMENTS' && <PaymentReport />}
        {activeTab === 'OPEN_INVOICES' && <OpenInvoicesReport />}
        {activeTab === 'INVOICE_VOLUME' && <InvoiceVolumeReport />}
      </div>
    </div>
  );
};

export default BuyerReporting;
